import './connection-error.css';

interface ConnectionErrorProps {
  /** Reintenta la carga que falló. */
  onRetry: () => void;
  /**
   * `true` (default) → ocupa el viewport (fixed), para el estado de error
   * PRIMARIO de una pantalla. `false` → embebido en una sección.
   */
  page?: boolean;
}

/**
 * ConnectionError — estado de error de CARGA primario (hermano del AppLoader).
 *
 * Se muestra cuando un fetch crítico de arranque (sesión vía `me()`, `/state`)
 * falla por red o servidor y NO hay dato cacheado para degradar suave: sin esto
 * la pantalla queda en loader infinito (o, en auth, pateaba a /login a quien
 * recargaba durante un deploy del backend). Ofrece "Reintentar" en vez de dejar
 * la app colgada.
 *
 * Usa el logo de marca pero QUIETO (no anima): no está "cargando", está
 * esperando una acción del usuario.
 */
export function ConnectionError({ onRetry, page = true }: ConnectionErrorProps) {
  return (
    <div className={page ? 'conn-err conn-err--page' : 'conn-err'} role="alert">
      <svg
        className="conn-err-orb"
        viewBox="0 0 240 240"
        width={56}
        height={56}
        aria-hidden
        role="img"
      >
        <circle cx="120" cy="120" r="74" fill="none" stroke="var(--purple)" strokeWidth="16" />
        <circle cx="190" cy="76" r="22" fill="var(--lime)" />
      </svg>
      <div className="conn-err-copy">
        <p className="conn-err-title">No pudimos conectar</p>
        <p className="conn-err-sub">Revisá tu conexión y reintentá.</p>
      </div>
      <button type="button" className="conn-err-retry" onClick={onRetry}>
        Reintentar
      </button>
    </div>
  );
}
